import { Routes } from '@angular/router';
import { AuthenticationGuard, AuthorizationGuard } from '@softline/auth';
import { SOFTLINE_PERMISSION_ABAU_INVOICE_LINK } from './invoice-link.shared';
import { ArchiveDocumentRepository } from './repositories/archive-document.repository';
import { DespatchadviceLinkRepository } from './repositories/despatchadvice-link.repository';
import {
  DeliveryNoteQueryRepository,
  InvoiceQueryRepository,
} from './repositories/document-query.repository';
import { ArchiveDocumentService } from './services/archive-document.service';
import { ArchivePanelState } from './services/archive-panel-state';
import { InvoiceLinkSessionService } from './services/invoice-link-session.service';
import {
  deliveryNotesExtraFilter,
  deliveryNotesFilter,
  invoicesExtraFilter,
  invoicesFilter,
  SOFTLINE_FILTER_ABAU_DELIVERY_NOTES,
  SOFTLINE_FILTER_ABAU_DELIVERY_NOTES_EXTRA,
  SOFTLINE_FILTER_ABAU_INVOICES,
  SOFTLINE_FILTER_ABAU_INVOICES_EXTRA,
} from './types/invoice-link-query.filter';

export const invoiceLinkRoutes: Routes = [
  {
    path: 'invoice-link',
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: { permission: SOFTLINE_PERMISSION_ABAU_INVOICE_LINK },
    providers: [
      InvoiceQueryRepository,
      DeliveryNoteQueryRepository,
      DespatchadviceLinkRepository,
      ArchiveDocumentRepository,
      ArchiveDocumentService,
      ArchivePanelState,
      InvoiceLinkSessionService,
      { provide: SOFTLINE_FILTER_ABAU_INVOICES, useFactory: () => invoicesFilter() },
      {
        provide: SOFTLINE_FILTER_ABAU_DELIVERY_NOTES,
        useFactory: () => deliveryNotesFilter(),
      },
      {
        provide: SOFTLINE_FILTER_ABAU_INVOICES_EXTRA,
        useFactory: () => invoicesExtraFilter(),
      },
      {
        provide: SOFTLINE_FILTER_ABAU_DELIVERY_NOTES_EXTRA,
        useFactory: () => deliveryNotesExtraFilter(),
      },
    ],
    loadComponent: () =>
      import('./pages/invoice-link/invoice-link.component').then(
        (c) => c.InvoiceLinkComponent
      ),
  },
];
